'use strict';

const { isEmpty } = require('lodash');
const { isRegexPatternValid } = require('../libs/utils');

/**
 *
 * @param {HTMLElement} el input
 * @returns {string} msg error
 */
function getFormValidationMsgError(el) {
    const $el = $(el);
    const elContent = $el.val();

    if (el.validity.valueMissing || isEmpty(elContent)) {
        return $el.attr('data-missing-error');
    }
    if (el.validity.patternMismatch || !isRegexPatternValid($el.attr('pattern'), elContent)) {
        return $el.attr('data-pattern-mismatch');
    }
    if (elContent.length < parseInt($el.attr('minLength'), 10)) {
        return $el.attr('data-range-error');
    }

    return '';
}

const handleErrorsFromServer = ($container, data) => {
    data.fieldErrors.forEach((fieldError) => {
        if (fieldError.id) {
            const $input = $container.find(`[name=${fieldError.id}]`);
            const $wrapper = $input.closest('.form-element');
            $wrapper.find('.error-text.custom-error').text(fieldError.error);
            $wrapper.addClass('has-custom-error');
        } else {
            const $formError = $('<li>');
            $formError.text(fieldError.error).appendTo($container.find('.form-global-errors'));
        }
    });

    if (data.fieldErrors.length > 0) {
        let $wrapper = $container.closest('.slider-container').find('.slider-wrapper');
        if ($wrapper.length === 0) {
            $wrapper = $([document.documentElement, document.body]);
        }

        $($wrapper).animate(
            {
                scrollTop: $container.offset().top,
            },
            500
        );
    }
};

const resetServerErrors = ($container) => {
    $container.find('.error-text.custom-error').text('');
    $container.find('.form-element').removeClass('has-custom-error');
    $container.find('.form-global-errors').empty();
};

$(() => {
    const passwordIconHandler = (e) => {
        const $icon = $(e.currentTarget);
        const $input = $icon.parent().find('input');
        // Toggle hide / show icons
        if ($icon.hasClass('icon-hide')) {
            $icon.removeClass('icon-hide').addClass('icon-show');
            $input.prop('type', 'text');
        } else {
            $icon.removeClass('icon-show').addClass('icon-hide');
            $input.prop('type', 'password');
        }
    };

    const $document = $(document);
    const $passwordIcon = $('.form-element.input-field:has(input[type=password]) .icon');

    $passwordIcon.off('click');
    $passwordIcon.on('click', passwordIconHandler);

    $document.on('click', '[type="submit"]', function () {
        const $this = $(this).closest('form');

        // Clear custom errors
        resetServerErrors($this);

        setTimeout(() => {
            const $errorEle = $this.find('.invalid-feedback:visible:not(:empty)').first();
            const $inputParent = $errorEle.closest('.form-element');
            if ($inputParent.length) {
                $('html, body').animate(
                    {
                        scrollTop: $inputParent.offset().top,
                    },
                    500
                );
            }
        }, 100);
    });

    $document.on('focusout', 'input[type="text"], input[type="password"]', function () {
        const $this = $(this);
        const fieldsWithConfirm = ['#registration-form-password', '#registration-form-email'];

        // Clear custom errors
        $this.closest('.form-element').removeClass('has-custom-error').find('.error-text.custom-error').text('');
        let errMsg = getFormValidationMsgError(this);
        let isErrorMessage = !isEmpty(errMsg);

        for (let i = 0; i < fieldsWithConfirm.length; i++) {
            let currentQuerry = fieldsWithConfirm[i];

            if ($this.is(currentQuerry + '-confirm')) {
                let isConfirmValid = $this.val() === $(currentQuerry).val();

                if (!isConfirmValid) {
                    errMsg = $this.data('range-error');
                    isErrorMessage = true;
                }
                $this[0].setCustomValidity(isConfirmValid ? '' : 'invalid');
            }
        }

        const $invalidFb = $this.closest('.input-text-wrapper').find('.invalid-feedback');
        if (isErrorMessage) {
            $invalidFb.text(errMsg);
            $this.addClass('is-invalid');
        } else {
            $invalidFb.empty();
            $this.removeClass('is-invalid');
        }
    });

    $document.off('keyup focusout').on('keyup focusout', 'input[type="text"], input[type="password"]', function () {
        const $this = $(this);

        // Clear custom errors
        $this.closest('.form-element').removeClass('has-custom-error').find('.error-text.custom-error').text('');

        let errMsg = getFormValidationMsgError(this);
        let isErrorMessage = !isEmpty(errMsg);
        const $invalidFb = $this.closest('.input-text-wrapper').find('.invalid-feedback');
        const $inputWrapper = $this.closest('.input-field');
        const isPasswordConfirm = $this.is('#registration-form-password-confirm');

        if (isPasswordConfirm) {
            const isPasswordConfirmValid = $this.val() === $('#registration-form-password').val();

            if (!isPasswordConfirmValid) {
                errMsg = $this.data('range-error');
                isErrorMessage = true;
            }
            this.setCustomValidity(isPasswordConfirmValid ? '' : 'invalid');
        }

        if (isErrorMessage) {
            $invalidFb.text(errMsg);
            $this.addClass('is-invalid');
            $inputWrapper.removeClass('valid');
        } else {
            $invalidFb.empty();
            $this.removeClass('is-invalid');
            $inputWrapper.addClass('valid');
        }
    });

    $(document).on('change', '.custom-select', function () {
        let $this = $(this);
        if ($this.hasClass('is-invalid') && $this.val !== '') {
            $this.removeClass('is-invalid');
            $this.closest('.form-element').find('.invalid-feedback').empty();
        }
    });

    $(document).on('change', '.registration .custom-select', function () {
        let $this = $(this);
        let $errorField = $this.closest('.dob-wrapper').find('.dob-day .invalid-feedback');
        if ($errorField.text() !== '' && $this.val !== '') {
            $errorField.empty();
        }
    });

    $document.on('change', 'input[type="radio"]', function () {
        const $this = $(this);
        if ($this && $this[0].checked) {
            $this.closest('.form-element').removeClass('has-custom-error').find('.invalid-feedback').text('');
        }
    });

    $document.on('custom:FormValidation', (e, eventData) => {
        handleErrorsFromServer(eventData.$container, eventData.data);
    });
});
